import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from '@norstella/nxp-sso-web/App'
import { Auth0ProviderWithNavigate } from '@norstella/nxp-sso-web/components/Auth0ProviderWithNavigate'
import { AppContextProvider } from '@norstella/nxp-sso-web/components/AppContextProvider'

import './index.css'
import { AxiosInterceptor } from '@norstella/nxp-sso-web/components/AxiosInterceptor'
import { RouteChangeHandler } from '@norstella/nxp-sso-web/components/RouteChangeHandler'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <AppContextProvider>
          <AxiosInterceptor>
            <RouteChangeHandler/>
            <App/>
          </AxiosInterceptor>
        </AppContextProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>,
)
